<br>
<div class="col-md-4 col-sm-6" style="min-width: 400px;margin-left:10px;">
  <mat-expansion-panel [expanded]=true class="accordionmargin">
    <mat-expansion-panel-header [expandedHeight]="'48px'">
      <mat-panel-title>
        Ändra lösenord för <br>{{actualmember?.id}} - {{actualmember?.givenname}} {{actualmember?.familyname}}
      </mat-panel-title>
      
    </mat-expansion-panel-header>

    <form *ngIf="!viewmembersearch" [formGroup]="form" style="margin-left:5px;margin-right:5px;">
      <i class="fa fa-key pull-right" aria-hidden="true" style="font-size:20px;display:inline-block;"
        title="Autogenerera ett lösenord" (click)="getRandomizedPassword()"></i>
      <i class="fa fa-question-circle pull-right" aria-hidden="true" (click)="displayPasswordRules=true"
        style="font-size:20px;display:inline-block;color:dodgerblue;" title="Regler för lösenord"></i>
      <div *ngIf="actualmember?.id === loggedinuser?.id" class="form-group" style="max-width: 250px;">
        <label for="currentPassword">
          Nuvarande lösenord <i class="fa fa-eye" (mouseover)="currpwshow=!currpwshow"
            (mouseout)="currpwshow=!currpwshow"></i>
        </label>
        <input [type]="currpwshow ? 'text' : 'password'" class="form-control form-control-sm" id="currentPassword" autocomplete="off"
          formControlName="currentPassword" required>
      </div>

      <div class="form-group" style="min-width: 230px;">
        <label for="password">
          Lösenord <i class="fa fa-eye" (mouseover)="pwshow=!pwshow" (mouseout)="pwshow=!pwshow"></i>
        </label>
        <input [type]="pwshow ? 'text' : 'password'" class="form-control form-control-sm" id="password" autocomplete="off"
          formControlName="password" required />
      </div>

      <div class="form-group" style="min-width: 250px;">
        <label for="passwordConfirmation">
          Konfirmera lösenord <i class="fa fa-eye" (mouseover)="confirmpwshow=!confirmpwshow"
            (mouseout)="confirmpwshow=!confirmpwshow"></i>
        </label>
        <input [type]="confirmpwshow ? 'text' : 'password'" class="form-control form-control-sm" autocomplete="off"
          id="passwordConfirmation" formControlName="passwordConfirmation" required>
      </div>
      <br>
      <div *ngIf="actualmember?.email" class="form-group" style="width: 98%;">

      <mat-checkbox #cb id="email" (change)="setEmail($event, cb);" formControlName="email"> Skicka kontoinformationen via epost till {{actualmember?.givenname}} {{actualmember?.familyname}}
      </mat-checkbox>

      </div>

      <div *ngIf="showemail" class="row">
        <div class="col-md-1">
        <span style="margin-left:3px;" title="Registrerad epostadress för {{actualmember?.givenname}} {{actualmember?.familyname}}"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
      </div>
      <div class="col-md-11">
        <span>{{actualmember?.email}}</span>
      </div>
    </div>

      <br>
      <div class="col-md-12">
        <div class="row">
          <button class="btn border ms-2" style="width: 80px;" (click)="changePassword()"
            [disabled]="!form.valid">Verkställ</button>
          <button class="btn border" style="width: 80px;margin-left: 20px;" (click)="cancel($event)">Avbryt</button>
        </div>
      </div>
    </form>

    <div *ngIf="viewmembersearch">
      <div class="form-group col-md-4">
        <label for="memberId">Medlemsnummer</label>
        <input type="text" class="form-group col-md-12" id="memberId" #memberid>
        <button class="btn border" (click)="memberSelected(memberid.value)">Välj</button>
      </div>
    </div>

    <hr />
    <div style="background-color:rgb(245, 253, 245);border-radius:5px;padding:10px;border:1px solid #F0F0F0;">
      <b>Regler för lösenord</b>
      <p>- Minst 8 tecken</p>
      <p>- Minst 4 unika tecken</p>
      <p>- Minst en siffra</p>
      <p>- Både stora och små bokstäver</p>
      <p>- Minst ett specialtecken (!&#64;$?_-)</p>
    </div>
  </mat-expansion-panel>
 
</div>

<p-dialog header="Regler för lösenord" [(visible)]="displayPasswordRules" [modal]="true" [style]="{width: '30vw'}"
  [baseZIndex]="10000" [draggable]="true" [resizable]="true">
  <p>- Minst 8 tecken</p>
  <p>- Minst 4 unika tecken</p>
  <p>- Minst en siffra</p>
  <p>- Både stora och små bokstäver</p>
  <p>- Minst ett specialtecken (!&#64;$?_-)</p>
</p-dialog>

 <div *ngIf="displayCancelDialog" class="card flex justify-center gap-2">
   <!--p-toast position="top-right" key="tr"></p-toast-->
    <!--p-confirmdialog /-->
</div>

<p-dialog 
  header="Information" 
  [(visible)]="displayInfoDialog" 
  [modal]="true" 
  [closable]="true">
  <p>Lösenordet ändrat. Du kommer loggas ut.</p>
  <button class="btn btn-secondary" (click)="logoffAndRevokeTokens()">Ok</button>
</p-dialog>